/**
 * 课程标准 api
 * 课程标准api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CompanyBaseVo from './CompanyBaseVo';
import IdNameVo from './IdNameVo';




  /**
   * The CompanyDeptVo model module.
   * @module course_standard/model/CompanyDeptVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>CompanyDeptVo</code>.
   * @alias module:course_standard/model/CompanyDeptVo
   * @class
   */
  var exports = function() {
    var _this = this;



  };

  /**
   * Constructs a <code>CompanyDeptVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:course_standard/model/CompanyDeptVo} obj Optional instance to populate.
   * @return {module:course_standard/model/CompanyDeptVo} The populated <code>CompanyDeptVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'company')) {
        obj['company'] = CompanyBaseVo.constructFromObject(data['company']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'dept')) {
        obj['dept'] = IdNameVo.constructFromObject(data['dept']);
      }
    }
    return obj;
  }

  /**
   * 公司
   * @member {module:course_standard/model/CompanyBaseVo} company
   */
  exports.prototype['company'] = undefined;
  /**
   * 所属分院
   * @member {module:course_standard/model/IdNameVo} dept
   */
  exports.prototype['dept'] = undefined;



  export default exports;
;


